import React, { useState } from "react";
import CommonPieChart from "../../../../components/common/Chart/CommonPieChart";
import { QuestionTypeCustom } from "../../../../Utils/enum";
import { useTranslation } from "react-i18next";

const colors = [
  "#FF6384",
  "#36A2EB",
  "#FFCE56",
  "#4BC0C0",
  "#9966FF",
  "#FF9F40",
  "#2ECC71",
  "#D81B60",
  "#3498DB",
];
const TakeResultStep2 = ({ result, handleSegmentClick }) => {
  const { t } = useTranslation();

  const questionStats = result?.data?.question_statistics || {};

  const questions = Object.keys(questionStats).map((key) => ({
    question: questionStats[key].question,
    type: questionStats[key].type || QuestionTypeCustom.ESSAY,
    answers: questionStats[key].answers || [],
    totalAnswers: questionStats[key].total_answers || 0,
  }));

  const chartTypes = [
    QuestionTypeCustom.MCQ,
    QuestionTypeCustom.CQ,
    QuestionTypeCustom.YES_NO,
    QuestionTypeCustom.CHECKBOX,
    QuestionTypeCustom.SLIDER,
  ];

  const [expandedAnswers, setExpandedAnswers] = useState({});

  const toggleExpand = (questionIndex, answerIndex) => {
    setExpandedAnswers((prev) => ({
      ...prev,
      [`${questionIndex}-${answerIndex}`]:
        !prev[`${questionIndex}-${answerIndex}`],
    }));
  };

  const prepareChartData = (answers) => {
    const uniqueOptions = {};
    answers.forEach((answer) => {
      const option = answer.option || "No option";
      uniqueOptions[option] =
        (uniqueOptions[option] || 0) + (answer.percentage || 0);
    });

    const totalPercentage = Object.values(uniqueOptions).reduce(
      (sum, val) => sum + val,
      0
    );
    const normalizedData =
      totalPercentage > 0
        ? Object.values(uniqueOptions).map(
            (val) => (val / totalPercentage) * 100
          )
        : Object.values(uniqueOptions);

    return {
      data: normalizedData,
      labels: Object.keys(uniqueOptions),
      colors: colors.slice(0, Object.keys(uniqueOptions).length),
    };
  };

  return (
    <section className="flex flex-col items-center mt-4">
      {questions.length > 0 ? (
        questions.map((item, questionIndex) => (
          <div
            key={questionIndex}
            className="w-full mt-4 border rounded-xl bg-white"
          >
            <article className="p-2 bg-white rounded-xl text-zinc-800">
              <p className="px-3 py-2 text-xs font-medium bg-yellow-50 rounded-lg">
                {t("quest.question")} {questionIndex + 1}: {item.question}
              </p>
              {chartTypes.includes(item.type) ? (
                <div className="w-full mt-3">
                  {item.answers.length > 0 ? (
                    <CommonPieChart
                      data={prepareChartData(item.answers).data}
                      labels={prepareChartData(item.answers).labels}
                      colors={prepareChartData(item.answers).colors}
                      title={`${item.question} Distribution`}
                      width="100%"
                      onSegmentClick={handleSegmentClick}
                    />
                  ) : (
                    <p className="px-3 py-2 mt-2 text-xs font-medium">
                      {t("base.noAnswerAvailable")}
                    </p>
                  )}
                </div>
              ) : (
                <>
                  {item.answers.length > 0 ? (
                    <ul className="mt-2 pl-5  text-xs">
                      {item.answers.map((answer, answerIndex) => {
                        const isExpanded =
                          expandedAnswers[`${questionIndex}-${answerIndex}`];
                        return (
                          <li
                            key={answerIndex}
                            className={`mb-1 cursor-pointer ${
                              !isExpanded ? "line-clamp-1" : ""
                            }`}
                            onClick={() =>
                              toggleExpand(questionIndex, answerIndex)
                            }
                          >
                            <span className="block">
                              {answerIndex + 1}. {answer.answer} (
                              {answer.percentage}%)
                            </span>
                            {!isExpanded &&
                              item.type !== "short" &&
                              `${answerIndex + 1}. ${answer.answer} (${
                                answer.percentage
                              }%)`.length > 50 && (
                                <span className="text-indigo-600 text-xs">
                                  ...
                                </span>
                              )}{" "}
                            {/* Ellipsis only for long text when not expanded and not short type */}
                          </li>
                        );
                      })}
                    </ul>
                  ) : (
                    <p className="px-3 py-2 mt-2 text-xs font-medium">
                      {t("base.noAnswerAvailable")}
                    </p>
                  )}
                  <p className="px-3 py-2 mt-2 text-xs font-medium">
                    {t("base.totalAnswers")}: {item.totalAnswers}
                  </p>
                </>
              )}
            </article>
          </div>
        ))
      ) : (
        <article className="p-2 bg-white rounded-xl text-zinc-800 w-full">
          <p className="px-3 py-2 text-xs font-medium bg-yellow-50 rounded-lg">
            {t("base.loadingQuestionData")}
          </p>
        </article>
      )}
    </section>
  );
};

export default TakeResultStep2;
